var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSsl = function SvgSsl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.128 27.04-4.44 1.892 5.281 1.22-.841-3.113Z",
    fill: "url(#SSL_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m28.101 27.04 4.438 1.892-5.28 1.22.842-3.113Z",
    fill: "url(#SSL_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.163 34.639c-1.973-.753-3.817-1.89-5.482-3.38-1.592-1.424-2.987-3.143-4.146-5.106a25.341 25.341 0 0 1-2.637-6.336 27.68 27.68 0 0 1-.931-7.147c0-1.242.084-2.497.25-3.73l.42-3.133 3.016.945c1.105.346 2.255.521 3.42.521 1.984 0 3.964-.528 5.724-1.527L20.112 5l1.316.747.058.032.006.003.084.045a11.63 11.63 0 0 0 5.576 1.446c1.165 0 2.315-.175 3.42-.521l3.015-.945.42 3.132c.167 1.235.25 2.49.25 3.73a27.67 27.67 0 0 1-.914 7.086 25.365 25.365 0 0 1-2.592 6.293c-1.139 1.952-2.51 3.666-4.078 5.094-1.636 1.49-3.451 2.639-5.395 3.41l-.047.02a13.69 13.69 0 0 1-.17.066l-.949.362-.948-.362Z",
    fill: "url(#SSL_svg__c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.796 32.979c-1.77-.675-3.428-1.698-4.93-3.043-1.457-1.303-2.736-2.88-3.803-4.686a23.564 23.564 0 0 1-2.45-5.892c-.578-2.16-.87-4.41-.87-6.689 0-1.162.078-2.338.233-3.494l.14-1.044 1.006.315c1.276.4 2.605.603 3.95.603 2.292 0 4.575-.608 6.601-1.758l.439-.249.438.249.098.054c.024.013.049.026.072.04a13.41 13.41 0 0 0 6.431 1.664 13.19 13.19 0 0 0 3.95-.602l1.005-.315.14 1.044a26.37 26.37 0 0 1 .235 3.494 25.91 25.91 0 0 1-.856 6.63 23.585 23.585 0 0 1-2.41 5.853c-1.047 1.797-2.305 3.37-3.739 4.676-1.478 1.346-3.111 2.38-4.855 3.074l-.05.02-.144.056-.316.12-.316-.12Z",
    fill: "url(#SSL_svg__d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.369 9.294a14.047 14.047 0 0 1-4.216.644c-2.388 0-4.74-.613-6.858-1.775-.06-.033-.121-.065-.181-.1a14.25 14.25 0 0 1-7.04 1.875c-1.439 0-2.852-.216-4.215-.644a25.384 25.384 0 0 0-.226 3.376c0 8.957 4.7 16.895 11.481 19.48.061-.023.121-.048.182-.072 6.682-2.657 11.3-10.532 11.3-19.408 0-1.127-.076-2.257-.227-3.376Z",
    fill: "url(#SSL_svg__e)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.101 14.307h-.057v-1.039a2.853 2.853 0 0 0-2.85-2.85 2.853 2.853 0 0 0-2.85 2.85v1.04h-.189c-.37 0-.67.3-.67.67v4.295c0 .37.3.67.67.67h5.947c.37 0 .67-.3.67-.67v-4.295c0-.37-.3-.67-.67-.67Zm-2.703 3.09v.972a.27.27 0 1 1-.54 0v-.972a.47.47 0 0 1 .27-.86.472.472 0 0 1 .27.86Zm1.847-4.129v1.04h-4.103v-1.04c0-1.132.92-2.052 2.052-2.052 1.131 0 2.052.92 2.052 2.052Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.539 28.932H7.685l-1.695-7.62h28.243l-1.694 7.62Z",
    fill: "url(#SSL_svg__f)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.651 26.088c0 .292-.075.554-.225.787-.151.234-.371.416-.661.548-.29.132-.634.198-1.032.198-.477 0-.87-.09-1.18-.27a1.572 1.572 0 0 1-.536-.52 1.179 1.179 0 0 1-.205-.63c0-.12.04-.221.123-.306a.42.42 0 0 1 .315-.127c.103 0 .19.033.262.099a.778.778 0 0 1 .183.293c.061.154.128.283.199.386a.805.805 0 0 0 .302.255c.13.068.3.1.51.1.29 0 .527-.067.708-.202.181-.135.272-.303.272-.506 0-.16-.05-.29-.147-.39a.948.948 0 0 0-.379-.23 6.554 6.554 0 0 0-.621-.167 4.552 4.552 0 0 1-.872-.285 1.408 1.408 0 0 1-.557-.445 1.155 1.155 0 0 1-.206-.701c0-.28.073-.502.218-.709.145-.206.354-.365.63-.476.274-.111.597-.167.968-.167.297 0 .554.037.77.11.216.074.396.172.539.294.143.122.247.25.313.384a.885.885 0 0 1 .099.392.463.463 0 0 1-.124.315.394.394 0 0 1-.308.14c-.112 0-.198-.028-.255-.084a1.133 1.133 0 0 1-.19-.276 1.244 1.244 0 0 0-.317-.427c-.123-.102-.32-.153-.593-.153-.253 0-.456.056-.611.167-.155.11-.233.244-.233.4 0 .097.026.18.08.25.052.071.125.131.217.182.092.05.185.09.28.119.095.029.25.07.468.125.272.064.519.134.74.211.22.077.408.17.564.28.154.11.275.25.362.417.087.168.13.374.13.618ZM22.153 26.088c0 .292-.075.554-.225.787a1.5 1.5 0 0 1-.661.548c-.29.132-.634.198-1.032.198-.477 0-.87-.09-1.18-.27a1.572 1.572 0 0 1-.536-.52 1.178 1.178 0 0 1-.205-.63c0-.12.04-.221.123-.306a.42.42 0 0 1 .315-.127c.103 0 .19.033.262.099a.778.778 0 0 1 .183.293c.061.154.128.283.199.386a.804.804 0 0 0 .302.255c.13.068.3.1.51.1.29 0 .527-.067.708-.202.181-.135.272-.303.272-.506 0-.16-.05-.29-.147-.39a.947.947 0 0 0-.38-.23 6.554 6.554 0 0 0-.62-.167 4.552 4.552 0 0 1-.872-.285 1.409 1.409 0 0 1-.557-.445c-.137-.188-.206-.422-.206-.701 0-.28.072-.502.217-.709.145-.206.355-.365.63-.476.275-.111.598-.167.97-.167.296 0 .553.037.77.11.215.074.395.172.538.294.143.122.247.25.313.384a.883.883 0 0 1 .099.392.463.463 0 0 1-.124.315.394.394 0 0 1-.308.14c-.112 0-.197-.028-.255-.084a1.132 1.132 0 0 1-.19-.276 1.242 1.242 0 0 0-.317-.427c-.123-.102-.32-.153-.593-.153-.253 0-.456.056-.612.167-.154.11-.232.244-.232.4 0 .097.026.18.08.25.052.071.125.131.217.182.092.05.185.09.28.119.094.029.25.07.468.125.272.064.519.134.74.211.22.077.408.17.563.28.155.11.276.25.363.417.087.168.13.374.13.618ZM23.944 23.216v3.517h1.984c.158 0 .28.039.364.116a.375.375 0 0 1 .127.29.37.37 0 0 1-.126.288c-.083.074-.205.11-.366.11h-2.363c-.213 0-.367-.046-.46-.14-.093-.095-.14-.248-.14-.46v-3.72c0-.198.044-.347.134-.445a.45.45 0 0 1 .35-.149.47.47 0 0 1 .358.147c.092.098.137.246.137.446Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SSL_svg__a",
    x1: 10.329,
    y1: 28.488,
    x2: 10.329,
    y2: 30.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0080AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0054AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SSL_svg__b",
    x1: 29.899,
    y1: 28.633,
    x2: 29.899,
    y2: 30.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0080AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0054AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SSL_svg__c",
    x1: 13.07,
    y1: 1.643,
    x2: 29.972,
    y2: 30.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7D63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#9ED33F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39B54A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SSL_svg__d",
    x1: 20.085,
    y1: 6.423,
    x2: 20.204,
    y2: 34.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39B54A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#9ED33F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7D63F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SSL_svg__e",
    x1: 20.113,
    y1: 8.063,
    x2: 20.113,
    y2: 32.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#285910"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09210C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SSL_svg__f",
    x1: 20.112,
    y1: 21.064,
    x2: 20.112,
    y2: 29.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DFF"
  })))));
};
export { SvgSsl as ReactComponent };
export default __webpack_public_path__ + "static/SSL.8e8d763d.svg";